import { Check, Cloud, CloudOff } from 'lucide-react';
import { cn } from '@/lib/utils';

export type SaveStatusValue = 'idle' | 'saving' | 'saved' | 'error';

export function SaveStatus({ status }: { status: SaveStatusValue }) {
  if (status === 'idle') return null;

  return (
    <div className={cn(
      "flex items-center gap-1.5 text-xs px-2 py-1 rounded-full transition-all duration-300",
      status === 'saving' && "text-blue-600 bg-blue-50",
      status === 'saved' && "text-green-600 bg-green-50",
      status === 'error' && "text-red-600 bg-red-50"
    )}>
      {status === 'saving' && (
        <>
          <Cloud className="h-3 w-3 animate-pulse" />
          <span>Saving...</span>
        </>
      )}
      {status === 'saved' && (
        <>
          <Check className="h-3 w-3" />
          <span>Saved</span>
        </>
      )}
      {status === 'error' && (
        <>
          <CloudOff className="h-3 w-3" />
          <span>Error saving</span>
        </>
      )}
    </div>
  );
}
